"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var OptionShapePropType = _propTypes.default.shape({
  label: _propTypes.default.string,
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]).isRequired,
  disabled: _propTypes.default.bool // Optional

});

var _default = OptionShapePropType;
exports.default = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9zZWxlY3QtbWVudS9zcmMvT3B0aW9uU2hhcGVQcm9wVHlwZS5qcyJdLCJuYW1lcyI6WyJPcHRpb25TaGFwZVByb3BUeXBlIiwiUHJvcFR5cGVzIiwic2hhcGUiLCJsYWJlbCIsInN0cmluZyIsInZhbHVlIiwib25lT2ZUeXBlIiwibnVtYmVyIiwiaXNSZXF1aXJlZCIsImRpc2FibGVkIiwiYm9vbCJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7O0FBQUE7O0FBRUEsSUFBTUEsbUJBQW1CLEdBQUdDLG1CQUFVQyxLQUFWLENBQWdCO0FBQzFDQyxFQUFBQSxLQUFLLEVBQUVGLG1CQUFVRyxNQUR5QjtBQUUxQ0MsRUFBQUEsS0FBSyxFQUFFSixtQkFBVUssU0FBVixDQUFvQixDQUFDTCxtQkFBVUcsTUFBWCxFQUFtQkgsbUJBQVVNLE1BQTdCLENBQXBCLEVBQTBEQyxVQUZ2QjtBQUcxQ0MsRUFBQUEsUUFBUSxFQUFFUixtQkFBVVMsSUFIc0IsQ0FHakI7O0FBSGlCLENBQWhCLENBQTVCOztlQU1lVixtQiIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBQcm9wVHlwZXMgZnJvbSAncHJvcC10eXBlcydcblxuY29uc3QgT3B0aW9uU2hhcGVQcm9wVHlwZSA9IFByb3BUeXBlcy5zaGFwZSh7XG4gIGxhYmVsOiBQcm9wVHlwZXMuc3RyaW5nLFxuICB2YWx1ZTogUHJvcFR5cGVzLm9uZU9mVHlwZShbUHJvcFR5cGVzLnN0cmluZywgUHJvcFR5cGVzLm51bWJlcl0pLmlzUmVxdWlyZWQsXG4gIGRpc2FibGVkOiBQcm9wVHlwZXMuYm9vbCAvLyBPcHRpb25hbFxufSlcblxuZXhwb3J0IGRlZmF1bHQgT3B0aW9uU2hhcGVQcm9wVHlwZVxuIl19


//////////////////
// WEBPACK FOOTER
// ./~/evergreen-ui/commonjs/select-menu/src/OptionShapePropType.js
// module id = 39
// module chunks = 0